<template>
  <div>
    <TheNavbar></TheNavbar>
    <div class="page-layout">
      <TheSidebar></TheSidebar>
      <main class="page-layout__content container layout--vertical">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script>
import TheNavbar from "@/components/navbar/TheNavbar";
import TheSidebar from "@/components/sidebar/TheSidebar";
export default {
  components: {
    TheSidebar,
    TheNavbar,
  },
};
</script>

<style lang="scss">
.page-layout {
  display: grid;
  grid-template-columns: min-content 1fr;
}
.page-layout__content {
  padding-top: 40px;
}

@media (min-width: 1281px) {
  .page-layout__content {
    padding-top: 40px;
    min-width: 1200px;
  }
}
</style>
